// eslint-disable-next-line
const lang = document.documentElement.lang.slice(0, 2); //TO DO
export const actions = {
  getSubscription: () => ({
    //
  }),
  startPreExersize: () => (dispatch, getState) => {
    dispatch(actions.generateNewLettersMatrix())
    dispatch({
      type: "PREEXERSIZE"
    })
  },
  highlightElement: () => ({
    type: "HIGHLIGHT"
  }),
  incrementCountDown: () => ({
    type: "INCREMENT_COUNTDOWN"
  }),
  increment: () => ({
    type: "INCREMENT"
  }),
  setIncrementCountDown: (newCountDown) => ({
    type: "SET_INCREMENT_COUNT_DOWN",
    newCountDown
  }),
  startGame: (newCountDown) => (dispatch, getState) => {
    dispatch(actions.setAutoHelp())
    dispatch({
      type: "START_GAME",
      newCountDown
    })
  },
  gameOverAction: () => (dispatch, getState) => {
    dispatch({
      type: "GAME_OVER"
    })
  },
  showAutoHelp: () => (dispatch, getState) => {
    let state = getState().GRID_SEARCH
    while(state.autoHelp.list[state.autoHelp.index].used) {
      state.autoHelp.index++      
    }
    if(state.autoHelp.list[state.autoHelp.index].cellsCount) {
      for(let j = state.autoHelp.list[state.autoHelp.index].columnIndex; 
        j<state.autoHelp.list[state.autoHelp.index].columnIndex + state.autoHelp.list[state.autoHelp.index].cellsCount; 
        j++) {
        state.gameMatrix[state.autoHelp.list[state.autoHelp.index].rowIndex][j].animation = 'textBlink'
      }
    } else {
      state.gameMatrix[state.autoHelp.list[state.autoHelp.index].rowIndex][state.autoHelp.list[state.autoHelp.index].columnIndex].animation = 'textBlink'
    }    
    state.autoHelp.list[state.autoHelp.index].used = true
    dispatch({
      type: "SHOW_AUTO_HELP"
    })
  },
  setAutoHelp: (newLeftToFind) => (dispatch, getState) => {    
    let state = getState().GRID_SEARCH
    if(state.autoHelp.timer) {
      clearTimeout(state.autoHelp.timer)
    }
    let timeOut = 15000
    let leftToFind = newLeftToFind? newLeftToFind : state.leftToFind
    if(leftToFind <= state.autoHelp.remainingForAutoHelp) {
      timeOut = 5000
    }
    state.autoHelp.timer = setTimeout( () => {
      dispatch(actions.showAutoHelp())
    },timeOut)
    dispatch({
      type: "SET_AUTO_HELP"
    })
  },
  generateNewLettersMatrix: () => (dispatch, getState) => {
    let state = getState().GRID_SEARCH
    let generatedData = state.gridSearchType.generateMatrix(state)
    dispatch({
      type: "GENERATE_MATRIX",
      gameMatrix: generatedData.gameMatrix,
      leftToFind: generatedData.leftToFind,
      lettersToFind: generatedData.lettersToFind,
      gridSearchType: generatedData.gridSearchType
    })
  },
  showGameOverScreanAction: () => ({
    type: "SHOW_GAME_OVER_SCREAN"
  }),
  cellClickAction: (rowIndex, columnIndex, value) => (dispatch, getState) => {
    let state = getState().GRID_SEARCH
    let newMatrix = state.gameMatrix
    let newPoints = state.points;
    let newWrongAnswers = state.wrongAnswers
    let newTimeLeft = state.timeLeft
    let newStep = state.exersizeState
    let newLeftToFind = state.leftToFind
    let clickResult
    let newLettersToFind = state.lettersToFind
    if (!newMatrix[rowIndex][columnIndex].isUsed) {
      if (newMatrix[rowIndex][columnIndex].special) {
        clickResult = state.gridSearchType.cellClick({
          newMatrix: newMatrix,
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          lettersToFind: state.lettersToFind    
        })
        if(clickResult.lettersToFind) {
          newLettersToFind = clickResult.lettersToFind
        }
        newMatrix = clickResult.newMatrix
        newPoints += state.POINTS_PER_CLICK
        newLeftToFind--
        if (newLeftToFind <= 0) {
          dispatch(actions.newRound())
          let state = getState().GRID_SEARCH
          newMatrix = state.gameMatrix
          newLeftToFind = state.leftToFind
          newLettersToFind = state.lettersToFind
        }
        //----------------------------------------------marck as used it helpers list-----------
        for( let i =0 ; i<state.autoHelp.list.length;i++) {
          if(state.autoHelp.list[i].cellsCount && state.autoHelp.list[i].rowIndex === rowIndex) {         
            if(columnIndex >= state.autoHelp.list[i].columnIndex && columnIndex < state.autoHelp.list[i].columnIndex + state.autoHelp.list[i].cellsCount) {              
              state.autoHelp.list[i].used = true
            }
          } else if(state.autoHelp.list[i].rowIndex === rowIndex && state.autoHelp.list[i].columnIndex === columnIndex) {
            state.autoHelp.list[i].used = true
          }
        }
        dispatch(actions.setAutoHelp(newLeftToFind))
        //----------------------------------------------------------------------------------------------
      } else {
        //---------------------------------------------------------------For correct animation of one Letter
        if (newMatrix[rowIndex][columnIndex].animation === 'redAnimation') {
          newMatrix[rowIndex][columnIndex].animation = 'redAnimationSecond'
        } else {
          newMatrix[rowIndex][columnIndex].animation = 'redAnimation'
        }
        //-----------------------------------------------------------------------------------------------------------------
        newWrongAnswers++
        if (newTimeLeft > 5) {
          newTimeLeft -= 5
        } else {
          newStep = 'gameOver';
          newTimeLeft = -1;
        }
      }
    }
    dispatch({
      type: "CELL_CLICK",
      gameMatrix: newMatrix,
      points: newPoints,
      wrongAnswers: newWrongAnswers,
      timeLeft: newTimeLeft,
      exersizeState: newStep,
      leftToFind: newLeftToFind,
      lettersToFind: newLettersToFind,
      leftToFind: newLeftToFind,
      autoHelp: state.autoHelp
    })
  },
  setType: (gridSearchType,POINTS_PER_CLICK,autoHelp) => ({
    type: "SET_GRID_SEARCH_TYPE",
    gridSearchType: gridSearchType,
    POINTS_PER_CLICK: POINTS_PER_CLICK,
    autoHelp: autoHelp
  }),
  newRound: () => (dispatch, getState) => {
    let state = getState().GRID_SEARCH
    dispatch(actions.generateNewLettersMatrix())    
    dispatch(actions.setAutoHelp())
    dispatch({
      type: "NEW_ROUND",
      currentRound: state.currentRound + 1
    })
  }
}
